/**
 * useLogout — POST /auth/logout (revokes session + blacklists JTI),
 * wipes the in-memory access token, clears the query cache, and
 * navigates to /login.
 *
 * If the network call fails (e.g. server unreachable) we still clear
 * local state and redirect — the user expects logout to "stick"
 * even when offline.
 */

import { useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { authApi, setAccessToken } from '@/lib/api'
import { ROUTES } from '@/lib/constants'

export function useLogout() {
  const navigate = useNavigate()
  const qc = useQueryClient()

  return async () => {
    try {
      await authApi.logout()
    } catch {
      // Ignored: we're logging out — server-side cleanup is best-effort.
    }
    setAccessToken(null)
    qc.clear()
    navigate(ROUTES.LOGIN, { replace: true })
  }
}
